import { type NavigationItem } from '@goto/shell-common'

export const getDefaultRoute = (navigationItems: readonly NavigationItem[]) => {
  if (navigationItems?.length) {
    return navigationItems[0].pathname
  }
}
